import { defineAction } from '~/prix'
import { z } from 'zod'
import creditEconomicMovementDeleteAction from './creditEconomicMovementDelete.action.json' with { type: 'json' }
import { creditEconomicMovementObject } from '../creditEconomicMovementObject'

const creditEconomicMovementDeleteDefinition = defineAction({
  ...creditEconomicMovementDeleteAction,

  input: z.object({ id: creditEconomicMovementObject.shape.id }),
  output: z.object({}),
})

export default creditEconomicMovementDeleteDefinition

